import React from 'react';
import { Box, FormHelperText, Link, Typography, useTheme } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { getDetailOfClientInCRM } from '../../helpers';

interface CaseWhatsappNumberWarningProps {
	message: string;
	clientId: string;
}

const CaseWhatsappNumberWarning: React.FC<CaseWhatsappNumberWarningProps> = ({
	message,
	clientId,
}: CaseWhatsappNumberWarningProps) => {
	const theme = useTheme();
	const clientUrl = getDetailOfClientInCRM(clientId);
	return (
		<FormHelperText sx={{ color: theme.palette.warning.main }}>
			<Box display="flex" alignItems="center" gap={0.5}>
				<WarningAmberIcon fontSize="small" fontWeight="bold" />
				<Typography variant="body2">
					{message}{' '}
					<Link
						href={clientUrl}
						target="_blank"
						rel="noopener noreferrer"
						sx={{ mt: 0.5, display: 'inline-block', color: theme.palette.warning.main, fontWeight: 'bold' }}
					>
						Click aquí para ver el cliente del caso
					</Link>
				</Typography>
			</Box>
		</FormHelperText>
	);
};

export default CaseWhatsappNumberWarning;
